var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFlagEnglish = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    verticalAlign: "middle"
  }
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
  fill: "#C4C4C4"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 15.5,
  width: 8.5,
  height: 8.5,
  fill: "#0A17A7"
}), /*#__PURE__*/React.createElement("rect", {
  width: 8.5,
  height: 8.5,
  fill: "#0A17A7"
}), /*#__PURE__*/React.createElement("rect", {
  y: 15.5,
  width: 8.5,
  height: 8.5,
  fill: "#0A17A7"
}), /*#__PURE__*/React.createElement("rect", {
  x: 15.5,
  y: 15.5,
  width: 8.5,
  height: 8.5,
  fill: "#0A17A7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.57538 2.45406L2.45406 4.57538L9.87868 12L2.45406 19.4246L4.57538 21.5459L12 14.1213L19.4246 21.5459L21.5459 19.4246L14.1213 12L21.5459 4.57538L19.4246 2.45406L12 9.87868L4.57538 2.45406Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 0H10V10H0V14H10V24H14V14H24V10H14V0Z",
  fill: "#E6273E"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.16116 20.1317L3.86827 20.8388L8.46446 16.2426C8.65972 16.0474 8.65972 15.7308 8.46446 15.5355C8.2692 15.3403 7.95262 15.3403 7.75735 15.5355L3.16116 20.1317ZM15.5355 8.46445C15.7308 8.65972 16.0474 8.65972 16.2426 8.46445L20.8388 3.86826L20.1317 3.16115L15.5355 7.75735C15.3403 7.95261 15.3403 8.26919 15.5355 8.46445ZM8.46447 7.75735C8.65973 7.95261 8.65973 8.26919 8.46447 8.46445C8.2692 8.65972 7.95262 8.65971 7.75736 8.46445L3.16117 3.86826L3.86827 3.16115L8.46447 7.75735ZM20.1317 20.8388L20.8388 20.1317L16.2426 15.5355C16.0474 15.3403 15.7308 15.3403 15.5355 15.5355C15.3403 15.7308 15.3403 16.0474 15.5355 16.2426L20.1317 20.8388Z",
  fill: "#E6273E"
}))));
export default SvgFlagEnglish;